<template>
  <div>
     <el-image 
      style="max-width: 120px; max-height: 120px"
      :src="item.content" 
      :preview-src-list="[item.content]">
    </el-image>
  </div>
</template>

<script>
export default {
  name: 'msgImage'
}
</script>

<style scoped>
.talk-photo {
  max-width: 100px;
  border: 1px #ccc solid;
}
</style>
